<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showConfirmacionInscripcion"
  >
    <!-- {{ categoriaSeleccionada }} -->
    <b-card-text v-if="action == 'delete'" class="my-1">
      El jugador será eliminado del periodo actual.
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <b-card-text v-if="action == 'deletePase'" class="my-1">
      El pase será anulado.
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <b-card-text v-else-if="action == 'inscripcion'" class="my-1">
      Una vez enviada la solicitud no podrás modificar ni agregar nuevos
      jugadores, Deberás esperar que la comisión revise la información
      proporcionada.
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <b-card-text v-else-if="action == 'responder'" class="my-1">
      Asegurate de marcar los jugadores con observaciones como revisado. En caso
      que no respondas la solicitud, el equipo no podrá seguir cargando
      información
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <b-card-text v-else-if="action == 'recalificacion'" class="my-1">
      El jugador ya ha sido Calificado previamente, al continuar actualizarás su
      fecha de calificación a la fecha actual y sera marcado como recalificado
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveAccion"
      >
        Aceptar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BCardText, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    playerSelected: Object,
    action: String,
    movimiento: String,
    categoriaSeleccionada: Object,
  },
  setup(props, { emit }) {
    const { postApi } = apiCall()
    async function insertSolicitudRevision() {
      // console.log(props.playerSelected)
      const dataSend = {
        id_equipo: props.playerSelected.id_equipo,
        id_campeonato: props.categoriaSeleccionada.campeonato.id_campeonato,
        id_usuario: USER().id_usuario,
      }
      const path = 'ApiInscripciones/insertSolicitudInscripcion'
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        emit('solicitudEnviada')
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          // eslint-disable-next-line
          false,
        )
        // playerData.isInReview = true
        // categoriaSeleccionada.value.isInReview = true
      } else {
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          // eslint-disable-next-line
          false,
        )
      }
    }
    async function deletePlayer() {
      const path = 'ApiInscripciones/deleteJugadorHistorial'
      // console.log(props)
      const dataSend = {
        idHistorial: props.playerSelected.id_historial,
        idPosicionToUpdate: props.playerSelected.id_update_posicion,
        movimiento: props.movimiento,
        idUserIngresa: USER().id_usuario,
        rol: USER().rol,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('eliminado', props.playerSelected)
      }
      store.commit(
        'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
        // eslint-disable-next-line
        false,
      )
    }
    async function recalificar() {
      const path = 'ApiInscripciones/actualizarJugador'
      // console.log(props.playerSelected)
      props.playerSelected.recalificar = true

      const response = await postApi(URL, path, props.playerSelected)
      if (response.flag === 'si') {
        emit('recargar', props.playerSelected.id_equipo)

        // initPlayer()
        store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          false,
        )
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ERROR no se pudo actualizar',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      }
    }
    async function deletePase() {
      const path = 'ApiInscripciones/deletePase'
      // console.log(props.playerSelected)
      const dataSend = {
        idPase: props.playerSelected.id_pase,
      }
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('eliminadoPase', props.playerSelected)
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          // eslint-disable-next-line
          false,
        )
      }
    }
    async function updateSolicitudRevision() {
      const path = 'ApiConfiguration/updateInscripcionEquipo'
      const response = await postApi(
        URL,
        path,
        // eslint-disable-next-line
        props.playerSelected.id_inscripcion,
      )
      // console.log(props.playerSelected)
      if (response.flag === 'si') {
        emit('revisado')
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          // eslint-disable-next-line
          false,
        )
      } else {
        // this.$toast(
        //   {
        //     component: ToastificationContent,
        //     props: {
        //       title: 'ERROR no se pudo actualizar',
        //       icon: 'AlertCircleIcon',
        //       variant: 'danger',
        //       solid: true,
        //     },
        //   },
        //   {
        //     position: 'top-center',
        //     // eslint-disable-next-line
        //   }
        // )
      }
    }
    function saveAccion() {
      if (props.action === 'delete') {
        deletePlayer()
      } else if (props.action === 'inscripcion') {
        insertSolicitudRevision()
      } else if (props.action === 'responder') {
        updateSolicitudRevision()
      } else if (props.action === 'deletePase') {
        deletePase()
      } else if (props.action === 'recalificacion') {
        recalificar()
      }
    }

    function close() {
      store.commit(
        'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
        // eslint-disable-next-line
        false,
      )
    }
    return {
      deletePlayer,
      close,
      saveAccion,
      updateSolicitudRevision,
      deletePase,
    }
  },
}
</script>
